import { cn } from '../../lib/cn';
import type { ADRRow } from '../../architecturegovernance/framework';

type Props = { adrs?: ADRRow[] };

export function ADRGovernancePanel({ adrs = [] }: Props) {
  return (
    <div className="space-y-2">
      {adrs.map((a) => (
        <div key={a.id} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-xs font-mono text-brand-600">{a.id}</p>
            <p className="text-sm font-medium">{a.title}</p>
            <p className="text-xs text-slate-500">Reviewer: {a.reviewer}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            a.status === 'accepted' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            a.status === 'proposed' ? 'bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300' :
            'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {a.status}
          </span>
        </div>
      ))}
    </div>
  );
}
